module.exports = __webpack_public_path__ + "img/Saman.a85ac8a3.svg";